import React, { useEffect, useState, lazy, Suspense } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ProtectedRoutes from "./router/protected.routes.tsx";
import Box from "@mui/material/Box";
import {
  Link,
  Navigate,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { FontSizeProvider } from "./components/FontSizeProvider";
import FontSizeControls from "./components/FontSizeControls";
import LoadingScreen from "./components/loading/index.js";
import { Icon } from "@iconify/react";
import ProtectedAdminRoute from "./router/ProtectedAdminRoute.tsx";

// Redux
import { RootReducers } from "./redux/reducers/index.ts";
import { useAppDispatch } from "./index.tsx";
import * as authActions from "./redux/actions/Auth.action.ts";
import { useSelector } from "react-redux";

// ใช้ lazy loading เพื่อลดขนาด bundle
const HomePage = lazy(() => import("./pages/HomePage/HomePage.tsx"));
const RegisterPage = lazy(() => import("./pages/AuthPage/Register.tsx"));
const LoginPage = lazy(() => import("./pages/AuthPage/Login.tsx"));
const LoginByUsername = lazy(
  () => import("./pages/AuthPage/LoginByUsername.tsx")
);
const ApproveScreen = lazy(() => import("./pages/AuthPage/ApproveScreen.tsx"));
const PreliminaryScreen = lazy(() => import("./pages/Preliminary/index.tsx"));
const PreliminaryChildrenScreen = lazy(
  () => import("./pages/Preliminary/children.tsx")
);
const ChildrenDetailScreen = lazy(
  () => import("./pages/Preliminary/children_detail.tsx")
);
const QuestionnaireScreen = lazy(
  () => import("./pages/Preliminary/questionnaire.tsx")
);
const AssessmentScreen = lazy(
  () => import("./pages/Preliminary/assessment.tsx")
);
const ViewVdo = lazy(() => import("./pages/KnowLedge/ViewVdo.tsx"));
const MenuScreen = lazy(() => import("./pages/Settings/menu.js"));
const AddChild = lazy(() => import("./pages/Preliminary/AddChild.tsx"));
const News = lazy(() => import("./pages/News/News.tsx"));
const WorkPlan = lazy(() => import("./pages/WorkPlan/WorkPlan.tsx"));
const UserGuide = lazy(() => import("./pages/UserGuide/UserGuide.tsx"));
const FormGuide = lazy(() => import("./pages/FormGuide/FormGuide.tsx"));
const ViewUserGuide = lazy(() => import("./pages/UserGuide/ViewPdf.tsx"));
const FromReport = lazy(() => import("./pages/FromReportNew/FromReport.tsx"));
const FromReport_new = lazy(
  () => import("./pages/FromReportNew/FromReport_new.tsx")
);
const ChildDetail = lazy(() => import("./pages/Preliminary/ChildDetail.tsx"));
const ChildSwap = lazy(() => import("./pages/ChildSwap/ChildSwap.tsx"));
const KiddiaryPage = lazy(() => import("./pages/KiddiarryPage/Kiddiarry.tsx"));
const ContacAdmin = lazy(() => import("./pages/contacAdmin/ContacAdmin.tsx"));
const NewDetail = lazy(() => import("./pages/News/NewDetail.tsx"));
const Notification = lazy(() => import("./pages/HomePage/Notification.tsx"));
const HowtoStep = lazy(() => import("./pages/HowtoStep/HowtoStep.tsx"));
const HealtRecords = lazy(
  () => import("./pages/KiddiarryPage/components/HealtRecords.tsx")
);
const AddHealtRecord = lazy(
  () => import("./pages/KiddiarryPage/components/AddHealthRecord.tsx")
);

const KidEducation = lazy(
  () => import("./pages/KiddiarryPage/components/KidEducation.tsx")
);
const KidHealth = lazy(
  () => import("./pages/KiddiarryPage/components/KidHealth.tsx")
);
const PDPAScreen = lazy(() => import("./pages/AuthPage/PDPAScreen.tsx"));
const AdminManager = lazy(
  () => import("./pages/AdminManager/AdminManager.tsx")
);
const OfficerPage = lazy(() => import("./pages/OfficerPage/OfficerPage.tsx"));
const UpdateUser = lazy(() => import("./pages/HomePage/UpdateUser.tsx"));
const LandingPage = lazy(() => import("./pages/LandingPage/LandingPage.tsx"));
const ChildConnect = lazy(
  () => import("./pages/ChildConnect/ChildConnect.tsx")
);
const FormByLink = lazy(
  () => import("./pages/AdminManager/pages/AdvancedOfficer/FormByLink.tsx")
);
const FromReportDetail = lazy(
  () => import("./pages/FromReportNew/FromReportDetail.tsx")
);
const ChildDevelopmentDetail = lazy(
  () => import("./pages/KiddiarryPage/components/ChildDevelopmentDetail.tsx")
);
const Safety = lazy(() => import("./pages/Safety/Safety.tsx"));
const ChildFromDetail = lazy(
  () => import("./pages/FromReportNew/components/ChildFromDetail.tsx")
);
const KiddiarryUpdate = lazy(
  () => import("./pages/KiddiarryPage/KiddiarryUpdate.tsx")
);
const Nanypage = lazy(
  () => import("./pages/KiddiarryPage/components/nanyPage.tsx")
);

const RegisterTeacher = lazy(
  () => import("./pages/AdminManager/pages/TeacherConnect/RegisterTeacher.tsx")
);
const PrintedForm = lazy(() => import("./pages/KnowLedge/PrintedForm.tsx"));
const VdoPage = lazy(() => import("./pages/KnowLedge/VdoPage.tsx"));
const ToyPage = lazy(() => import("./pages/KnowLedge/ToyPage.tsx"));
const DocGuide = lazy(() => import("./pages/KnowLedge/DocGuide.tsx"));

//ADMIN
const ChildList = lazy(
  () => import("./pages/AdminManager/pages/Child/ChildList.tsx")
);
const OutOfAgeList = lazy(
  () => import("./pages/AdminManager/pages/OutOfAge/OutOfAgeList.tsx")
);
const WithKids = lazy(
  () => import("./pages/AdminManager/pages/WithKids/ChildList.tsx")
);
const ChildConnectList = lazy(
  () => import("./pages/AdminManager/pages/ChildConnect/ChildConnectList.tsx")
);
const PersonnelList = lazy(
  () => import("./pages/AdminManager/pages/Personnel/PersonnelList.tsx")
);
const AdvancedOfficerList = lazy(
  () =>
    import("./pages/AdminManager/pages/AdvancedOfficer/AdvancedOfficerList.tsx")
);
const OfficerList = lazy(
  () => import("./pages/AdminManager/pages/Officer/OfficerList.tsx")
);

const RegisterOfficer = lazy(
  () => import("./pages/AdminManager/pages/Officer/RegisterOfficer.tsx")
);

const DepartmentList = lazy(
  () => import("./pages/AdminManager/pages/Department/DepartMentList.tsx")
);
const NewsList = lazy(
  () => import("./pages/AdminManager/pages/News/NewsList.tsx")
);

const ParentConnect = lazy(
  () => import("./pages/AdminManager/pages/ParentConnect/ParentConnectList.tsx")
);

const TeacherConnect = lazy(
  () =>
    import("./pages/AdminManager/pages/TeacherConnect/TeacherConnectList.tsx")
);

const ChildIsNotComplete = lazy(
  () => import("./pages/AdminManager/pages/ChildIsNotComplete/ChildList.tsx")
);

const UpdateIncomplete = lazy(
  () => import("./pages/HomePage/UpdateIncomplete.tsx")
);

const ChildInOut = lazy(
  () => import("./pages/AdminManager/pages/ChildInOut/ChildInOut.tsx")
);

const HowToUse = lazy(() => import("./pages/HowToUse/HowToUse.tsx"));

// กำหนดธีมของแอปพลิเคชัน
const theme = createTheme({
  typography: {
    fontFamily: "Bai Jamjuree",
    fontWeightLight: 200,
    fontWeightRegular: 400,
    fontWeightMedium: 400,
    fontWeightBold: 500,
  },
  palette: {
    primary: {
      main: "#5C30DF",
      light: "#8159FF",
      dark: "#4920b7",
      contrastText: "#fff",
    },
    secondary: {
      main: "#F43B52",
      light: "#FF6B7A",
      dark: "#CA1A31",
      contrastText: "#fff",
    },
    background: {
      default: "#F5F5F5",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#00164C",
      secondary: "#6B7280",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          fontWeight: 500,
        },
      },
    },
  },
});

// Component แสดงหน้า 404
const NotFound = () => (
  <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
    <div className="text-center">
      <Icon
        icon="tabler:error-404"
        className="text-gray-500 w-24 h-24 mx-auto"
      />
      <h1 className="text-4xl font-bold text-[#00164C] mt-4">
        404 - ไม่พบหน้านี้
      </h1>
      <p className="text-gray-600 mt-2 text-lg">
        ขออภัย! หน้าที่คุณกำลังค้นหาไม่มีอยู่หรือถูกย้าย
      </p>
      <Link
        to="/HomePage"
        className="mt-6 inline-block px-6 py-3 bg-purple-600 text-white text-lg font-semibold rounded-lg shadow-md hover:bg-purple-700 transition duration-300"
      >
        กลับหน้าหลัก
      </Link>
    </div>
  </div>
);

// สร้าง Log function สำหรับ dev เพื่อใช้ในการตรวจสอบการทำงาน
// const Logger = {
//   log: (message: string, data?: any) => {
//     if (
//       process.env.NODE_ENV === "development" ||
//       process.env.REACT_APP_MODE === "DEV"
//     ) {
//       //// // console.log(`%c${message}`, "color: #3498db", data || "");
//     }
//   },
//   error: (message: string, error?: any) => {
//     if (
//       process.env.NODE_ENV === "development" ||
//       process.env.REACT_APP_MODE === "DEV"
//     ) {
//       console.error(`%c${message}`, "color: #e74c3c", error || "");
//     }
//   },
//   warn: (message: string, data?: any) => {
//     if (
//       process.env.NODE_ENV === "development" ||
//       process.env.REACT_APP_MODE === "DEV"
//     ) {
//       console.warn(`%c${message}`, "color: #f39c12", data || "");
//     }
//   },
// };

// สร้าง Array ของเส้นทางที่ไม่ต้องการให้ต้อง login
const publicRoutes = [
  "/ContacAdmin",
  "/UserGuide",
  "/NewDetail",
  "/LandingPage",
  "/FormByLink",
];

export default function App() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useSelector((state: RootReducers) => state.AuthReducer);
  const [hasAuthenticated, setHasAuthenticated] = useState(false);

  // Logger.log("App mode:", process.env.REACT_APP_MODE);
  // Logger.log("Current path:", location.pathname);

  // ตรวจสอบสถานะการยืนยันตัวตนของผู้ใช้
  useEffect(() => {
    if (auth.result?.data) {
      setHasAuthenticated(true);
      // Logger.log("Auth state detected in store:", auth.result.data);
    }
  }, [auth.result?.data]);

  // การจัดการการตรวจสอบสิทธิ์และการเข้าถึงหน้าต่างๆ
  useEffect(() => {
    const initialize = async () => {
      try {
        // ตรวจสอบว่าเส้นทางปัจจุบันเป็นเส้นทางสาธารณะหรือไม่
        const isPublicRoute = [
          "/",
          "/ContacAdmin",
          "/UserGuide",
          "/NewDetail",
          "/LandingPage",
          "/FormByLink",
          "/LoginByUsername",
          "/RegisterPage",
        ].some(
          (route) =>
            location.pathname === route ||
            location.pathname.startsWith(route + "/")
        );

        // ถ้าเป็นเส้นทางสาธารณะ ข้ามการตรวจสอบ
        if (isPublicRoute) {
          // Logger.log(
          //   "Accessing public route, skipping LIFF login:",
          //   location.pathname
          // );
          setLoading(false);
          return;
        }

        // ถ้า authenticate แล้ว ให้ข้ามการตรวจสอบ
        if (hasAuthenticated) {
          // Logger.log("Already authenticated, skipping auth process");
          setLoading(false);
          return;
        }

        // จัดการ redirect ถ้ามีใน localStorage
        const storedRedirect = localStorage.getItem("redirectPath");
        if (storedRedirect) {
          localStorage.removeItem("redirectPath");
          navigate(storedRedirect, { replace: true });
        }
      } catch (error) {
        // Logger.error("Authentication initialization failed", error);
      } finally {
        setLoading(false);
      }
    };

    initialize();
  }, [
    dispatch,
    navigate,
    location.pathname,
    hasAuthenticated,
    auth.result?.data,
  ]);

  if (loading) return <LoadingScreen />;

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
        <Suspense fallback={<LoadingScreen />}>
          <Routes>
            <Route path="/" element={<Navigate to="/LandingPage" replace />} />

            {/* Public Routes */}
            <Route path="/RegisterPage" element={<RegisterPage />} />
            <Route path="/LoginPage" element={<LoginPage />} />
            <Route path="/LoginByUsername" element={<LoginByUsername />} />
            <Route path="/LandingPage" element={<LandingPage />} />
            <Route path="/ContacAdmin" element={<ContacAdmin />} />
            <Route path="/UserGuide" element={<UserGuide />} />
            <Route path="/NewDetail" element={<NewDetail />} />
            <Route path="/FormByLink/:id" element={<FormByLink />} />
            <Route path="/PDPAScreen" element={<PDPAScreen />} />
            <Route path="/ApproveScreen" element={<ApproveScreen />} />
            <Route path="/News" element={<News />} />
            <Route path="/HealtRecords" element={<HealtRecords />} />
            <Route path="/AddHealtRecord" element={<AddHealtRecord />} />
            <Route path="/ViewVdo" element={<ViewVdo />} />
            <Route path="/PrintedForm" element={<PrintedForm />} />
            <Route path="/VdoPage" element={<VdoPage />} />
            <Route path="/ToyPage" element={<ToyPage />} />
            <Route path="/DocGuide" element={<DocGuide />} />
            <Route
              path="/ViewUserGuide/:fileName"
              element={<ViewUserGuide />}
            />
            <Route
              path="/documents/manual/:fileName"
              element={<ViewUserGuide />}
            />
            <Route path="/RegisterTeacher/:id" element={<RegisterTeacher />} />
            <Route path="/RegisterOfficer/:id" element={<RegisterOfficer />} />
            <Route path="/HowtoStep" element={<HowtoStep />} />
            <Route path="/HowToUse" element={<HowToUse />} />
            {/* Protected Routes - ใช้ element prop */}
            <Route element={<ProtectedRoutes />}>
              <Route path="/HomePage" element={<HomePage />} />
              <Route
                path="/PreliminaryScreen"
                element={<PreliminaryScreen />}
              />
              <Route
                path="/PreliminaryChildrenScreen"
                element={<PreliminaryChildrenScreen />}
              />
              <Route
                path="/ChildrenDetailScreen/:id"
                element={<ChildrenDetailScreen />}
              />
              <Route
                path="/QuestionnaireScreen/:id"
                element={<QuestionnaireScreen />}
              />
              <Route path="/AssessmentScreen" element={<AssessmentScreen />} />
              <Route path="/MenuScreen" element={<MenuScreen />} />
              <Route path="/AddChild" element={<AddChild />} />

              <Route path="/WorkPlan" element={<WorkPlan />} />
              <Route path="/FormGuide" element={<FormGuide />} />

              <Route path="/FromReport" element={<FromReport_new />} />
              <Route path="/ChildDetail" element={<ChildDetail />} />
              <Route path="/ChildSwap" element={<ChildSwap />} />
              <Route path="/KiddiaryPage" element={<KiddiaryPage />} />
              <Route path="/Notification" element={<Notification />} />
              <Route path="/KidEducation" element={<KidEducation />} />
              <Route path="/KidHealth" element={<KidHealth />} />
              <Route path="/nanyPage" element={<Nanypage />} />

              <Route path="/OfficerPage" element={<OfficerPage />} />
              <Route path="/UpdateUser" element={<UpdateUser />} />
              <Route path="/ChildConnect" element={<ChildConnect />} />
              <Route path="/FromReportDetail" element={<FromReportDetail />} />
              <Route
                path="/ChildDevelopmentDetail"
                element={<ChildDevelopmentDetail />}
              />
              <Route path="/Safety" element={<Safety />} />
              <Route path="/ChildFromDetail" element={<ChildFromDetail />} />
              <Route path="/KiddiarryUpdate" element={<KiddiarryUpdate />} />

              <Route path="/UpdateIncomplete" element={<UpdateIncomplete />} />
              {/* Font Size Provider */}
              {/* Font Size Controls */}
              {/* //ADMIN */}
              <Route
                path="/admin/ChildList"
                element={
                  <ProtectedAdminRoute>
                    <ChildList />
                  </ProtectedAdminRoute>
                }
              />
              <Route
                path="/admin/OutOfAgeList"
                element={
                  <ProtectedAdminRoute>
                    <OutOfAgeList />
                  </ProtectedAdminRoute>
                }
              />
              <Route
                path="/admin/WithKidsList"
                element={
                  <ProtectedAdminRoute>
                    <WithKids />
                  </ProtectedAdminRoute>
                }
              />
              <Route
                path="/admin/ChildConnectList"
                element={
                  <ProtectedAdminRoute>
                    <ChildConnectList />
                  </ProtectedAdminRoute>
                }
              />
              <Route
                path="/admin/PersonnelList"
                element={
                  <ProtectedAdminRoute>
                    <PersonnelList />
                  </ProtectedAdminRoute>
                }
              />
              <Route
                path="/admin/AdvancedOfficerList"
                element={
                  <ProtectedAdminRoute>
                    <AdvancedOfficerList />
                  </ProtectedAdminRoute>
                }
              />
              <Route
                path="/admin/OfficerList"
                element={
                  <ProtectedAdminRoute>
                    <OfficerList />
                  </ProtectedAdminRoute>
                }
              />
              <Route
                path="/admin/DepartmentList"
                element={
                  <ProtectedAdminRoute>
                    <DepartmentList />
                  </ProtectedAdminRoute>
                }
              />
              <Route
                path="/admin/NewsList"
                element={
                  <ProtectedAdminRoute>
                    <NewsList />
                  </ProtectedAdminRoute>
                }
              />

              <Route
                path="/admin/ParentConnect"
                element={
                  <ProtectedAdminRoute>
                    <ParentConnect />
                  </ProtectedAdminRoute>
                }
              />
              <Route
                path="/admin/TeacherConnect"
                element={
                  <ProtectedAdminRoute>
                    <TeacherConnect />
                  </ProtectedAdminRoute>
                }
              />
            </Route>

            <Route
              path="/admin/ChildIsNotComplete"
              element={
                <ProtectedAdminRoute>
                  <ChildIsNotComplete />
                </ProtectedAdminRoute>
              }
            />

            <Route
              path="/admin/ChildInOut"
              element={
                <ProtectedAdminRoute>
                  <ChildInOut />
                </ProtectedAdminRoute>
              }
            />

            {/* Admin Protected Route */}
            <Route
              path="/AdminManager"
              element={
                <ProtectedAdminRoute>
                  <AdminManager />
                </ProtectedAdminRoute>
              }
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Box>
    </ThemeProvider>
  );
}
